import './payment-element.scss';
import {AddressElement, PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import React, {useContext, useEffect, useState} from "react";
import {PortfolioContext} from "../../../../hooks/Context/PortfolioContext";
import {useNavigate, useParams} from "react-router-dom";
import AlertModal from "../../../../components/UI/Modals/AlertModal/AlertModal";
import {CheckCircle} from '@phosphor-icons/react';
import {useQueryUserInfo} from "../../../../api/admin/useQueryUserInfo";
import Notification from "../../../../components/UI/Notification/Notification";
import {AddressMode} from "@stripe/stripe-js/dist/stripe-js/elements/address";
import {Layout, LayoutObject} from "@stripe/stripe-js/dist/stripe-js/elements/payment";
import {useMutatePaymentIntent} from "../../../../api/payment/useMutatePaymentIntent";
import ButtonKMQ from "../../../../components/UI/Button/ButtonKMQ";
import ErrorKMQ from "../../../../components/UI/Error/ErrorKMQ";
import {ButtonTypes} from "../../../../constants/ui/types/ButtonTypes";
import {UserContext} from "../../../../hooks/Context/UserContext";

const Payment = ({refetchCart}: {refetchCart: () => void}) => {
  const [user] = useContext(UserContext);
  const navigate = useNavigate();
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const {session_id} = useParams();
  const {refetch: refetchPortfolio} = useQueryUserInfo({});
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [addressIsValid, setAddressIsValid] = useState<boolean>(false);

  const {
    mutate: updatePaymentIntent,
    isSuccess: isSuccessIntentEditing
  } = useMutatePaymentIntent({payment_intent_id: session_id});

  const closeModal = () => {
    setSuccessModal(false);
    //setPortfolio({...portfolio, clientSecret: undefined});
    refetchPortfolio().then(response => {
      if (response.data) {
        setPortfolio({
          ...response.data,
          clientSecret: undefined,
          banner_text: undefined
        })
      }
    })
    navigate('/cpl-applicant/my-programs');
    window.location.reload();
  }

  const stripe = useStripe();
  const appearance = {
    rules: {
      '.Input': {
        width: '50%'
      }
    }
  };
  const elements = useElements();
  //const elements = stripe ? stripe.elements({appearance}) : null;

  const [message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    if (!addressIsValid) {
      setMessage('Address is not valid.');
      return;
    }

    setIsLoading(true);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + '/cpl-applicant/my-programs'
      },
    });

    /*if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message ?? '');
    } else {
      setMessage("An unexpected error occurred.");
    }*/

    setIsLoading(false);
  };

  const handlePaymentChange = async (e: any) => {
    if (e?.value?.address?.postal_code) {
      setAddressIsValid(true);
      updatePaymentIntent({
        postal_code: e?.value?.address?.postal_code,
        country: e?.value?.address?.country
      })
    }
  }

  const paymentElementOptions: { layout: LayoutObject | Layout } = {
    layout: "tabs",
  }

  const addressOptions: { mode: AddressMode } = {
    mode: 'billing',
  };

  useEffect(() => {
    if (isSuccessIntentEditing) {
      setMessage('');
      refetchCart();
    }
  }, [isSuccessIntentEditing, refetchCart])

  if (!elements) {
    return null;
  }

  return <div id="checkout" className={'payment-element'}>
    {
      portfolio.banner_text
        ? <Notification>
            <span
              dangerouslySetInnerHTML={{__html: portfolio.banner_text}}
            />
        </Notification>
        : null
    }
    <form id="payment-form" onSubmit={handleSubmit}>
      <div>
        <AddressElement
          options={addressOptions}
          onChange={handlePaymentChange}

        />
      </div>

      <div>
        <PaymentElement
          id="payment-element"
          options={paymentElementOptions}
        />
      </div>


      <div className={'payment-element-submit'}>
        <ButtonKMQ
          id="submit" onClick={() => null}
          disabled={isLoading || !stripe || !elements || user.isSoft}
          type={ButtonTypes.Tertiary}
        >
          Pay now
        </ButtonKMQ>
      </div>

      {message && <ErrorKMQ error={message}/>}
    </form>

    <AlertModal
      open={successModal}
      onClose={closeModal}
      title={'Payment and submission success'}
      text={'Thank you for your payment. We have successfully received your submission.'}
      onProceed={closeModal}
      proceedText={'Return to Recommendations'}
      icon={<CheckCircle size={56} color={'#212121'}/>}
    />
  </div>
}

export default Payment;